import { type ApiBaseError, type SimInventoryBaseErrorReturn, getStandardHeaders } from './shared';

const getFetcher = async (url: string) => {
  const response = await fetch(url, {
    credentials: 'include',
    method: 'GET',
    headers: getStandardHeaders(),
  });

  if (!response.ok) {
    const error: ApiBaseError = new Error('An error occurred while fetching the data.');
    error.info = (await response.json()) as SimInventoryBaseErrorReturn;
    error.status = response.status;
    throw error;
  }

  const resultJson = await response.json();
  return resultJson;
};

export default getFetcher;
